module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('main', [_c('aside', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    attrs: {
      "x": "0px",
      "y": "0px",
      "width": "150px",
      "height": "40px"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": "#2d4c8b",
      "points": "150,40 7.001,40 0,33 0,7 6.918,0 150,0 "
    }
  }), _vm._v(" "), _c('image', {
    attrs: {
      "xlink:href": "/static/assets/images/facebook.png",
      "x": "23",
      "y": "10",
      "width": "9px",
      "height": "18px"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "55",
      "y": "24"
    }
  }, [_vm._v("Like Us!")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    attrs: {
      "x": "0px",
      "y": "0px",
      "width": "150px",
      "height": "40px"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": "#34dfe6",
      "points": "150,40 7.001,40 0,33 0,7 6.918,0 150,0 "
    }
  }), _vm._v(" "), _c('image', {
    attrs: {
      "xlink:href": "/static/assets/images/twitter.png",
      "x": "17",
      "y": "12",
      "width": "23px",
      "height": "16px"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "55",
      "y": "24"
    }
  }, [_vm._v("Follow Us!")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    attrs: {
      "x": "0px",
      "y": "0px",
      "width": "150px",
      "height": "40px"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": "#e842ab",
      "points": "150,40 7.001,40 0,33 0,7 6.918,0 150,0 "
    }
  }), _vm._v(" "), _c('image', {
    attrs: {
      "xlink:href": "/static/assets/images/flickr.png",
      "x": "17",
      "y": "16",
      "width": "18px",
      "height": "7px"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "55",
      "y": "24"
    }
  }, [_vm._v("Flickr")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    attrs: {
      "x": "0px",
      "y": "0px",
      "width": "150px",
      "height": "40px"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": "#ff9000",
      "points": "150,40 7.001,40 0,33 0,7 6.918,0 150,0 "
    }
  }), _vm._v(" "), _c('image', {
    attrs: {
      "xlink:href": "/static/assets/images/rss.png",
      "x": "18",
      "y": "12",
      "width": "16px",
      "height": "16px"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "55",
      "y": "24"
    }
  }, [_vm._v("Rss Feed")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('svg', {
    attrs: {
      "x": "0px",
      "y": "0px",
      "width": "150px",
      "height": "40px"
    }
  }, [_c('polygon', {
    attrs: {
      "fill": "#33517f",
      "points": "150,40 7.001,40 0,33 0,7 6.918,0 150,0 "
    }
  }), _vm._v(" "), _c('image', {
    attrs: {
      "xlink:href": "/static/assets/images/vimeo.png",
      "x": "18",
      "y": "13",
      "width": "17px",
      "height": "15px"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "55",
      "y": "24"
    }
  }, [_vm._v("Vimeo")])])])]), _vm._v(" "), _c('component-header'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('component-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('ul', {
    staticClass: "main-slider"
  }, [_c('li', {
    staticClass: "first"
  }, [_c('h1', {
    staticStyle: {
      "color": "#ff6600"
    }
  }, [_vm._v("One Stop")]), _vm._v(" "), _c('h6', [_vm._v("Get a taste of what you can find in our venue")]), _vm._v(" "), _c('a', {
    staticClass: "square-button",
    staticStyle: {
      "background": "#339900"
    },
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_vm._v("Make a tour")])]), _vm._v(" "), _c('li', {
    staticClass: "second"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ff6600"
    }
  }, [_vm._v("Touch Down")]), _vm._v(" "), _c('h6', [_vm._v("Get a taste of what you can find in our venue")]), _vm._v(" "), _c('a', {
    staticClass: "square-button",
    staticStyle: {
      "background": "#339900"
    },
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_vm._v("Go to shop")])]), _vm._v(" "), _c('li', {
    staticClass: "third"
  }, [_c('h2', {
    staticStyle: {
      "color": "#ff6600"
    }
  }, [_vm._v("Full Events")]), _vm._v(" "), _c('h6', [_vm._v("Get a taste of what you can find in our venue")]), _vm._v(" "), _c('a', {
    staticClass: "square-button",
    staticStyle: {
      "background": "#339900"
    },
    attrs: {
      "href": "#",
      "target": "_blank"
    }
  }, [_vm._v("make a schedule")])])]), _vm._v(" "), _c('div', {
    staticClass: "pager-container"
  }, [_c('a', {
    attrs: {
      "href": "",
      "data-slide-index": "0"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "data-slide-index": "1"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "",
      "data-slide-index": "2"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "our-dishes"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Stanel World")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('article', {
    attrs: {
      "id": "dishes-left"
    }
  }, [_c('article', [_c('div', [_c('h5', [_vm._v("Farmers Market")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/site1.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cta-card-md"
  }, [_c('span', {
    staticClass: "cta-words"
  }, [_vm._v("Lorem ipsum dolor sit amet dolor sit amet")]), _vm._v(" "), _c('span', {
    staticClass: "cta"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "farmmarket"
    }
  }, [_vm._v("visit")])])])]), _vm._v(" "), _c('article', [_c('div', [_c('h5', [_vm._v("P & J Supermarket ")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/site2.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cta-card-md"
  }, [_c('span', {
    staticClass: "cta-words"
  }, [_vm._v("Lorem ipsum dolor sit amet dolor sit amet")]), _vm._v(" "), _c('span', {
    staticClass: "cta"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "pjsupermarket"
    }
  }, [_vm._v("visit")])])])])]), _vm._v(" "), _c('article', {
    attrs: {
      "id": "dishes-right"
    }
  }, [_c('article', [_c('div', [_c('h5', [_vm._v("Chicken Republic Drive Thru")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/site3.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cta-card-md"
  }, [_c('span', {
    staticClass: "cta-words"
  }, [_vm._v("Lorem ipsum dolor sit amet dolor sit amet")]), _vm._v(" "), _c('span', {
    staticClass: "cta"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "chickenrepublic"
    }
  }, [_vm._v("visit")])])])]), _vm._v(" "), _c('article', [_c('div', [_c('h5', [_vm._v("Essense Spa")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/site4.jpg",
      "alt": "sandwiches"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cta-card-md"
  }, [_c('span', {
    staticClass: "cta-words"
  }, [_vm._v("Lorem ipsum dolor sit amet dolor sit amet")]), _vm._v(" "), _c('span', {
    staticClass: "cta"
  }, [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "essencespa"
    }
  }, [_vm._v("visit")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "shows"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "35%",
      "padding-top": "-3em"
    },
    attrs: {
      "src": "/static/assets/images/december.png",
      "alt": "show-model"
    }
  }), _vm._v(" "), _c('article', [_c('h3', [_vm._v("Live"), _c('span', [_vm._v("Shows")])]), _vm._v(" "), _c('p', [_vm._v("Every Saturday")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea  derma commodo consequat. ")]), _vm._v(" "), _c('a', {
    staticClass: "square-button",
    attrs: {
      "href": "events.html",
      "target": "_blank"
    }
  }, [_vm._v("Check all the events")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "popular-dishes"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Popular Dishes")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', {
    staticClass: "dishes"
  }, [_c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat1.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Mozzarella Cheeseburger")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$15.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat2.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Barbeque Steak Strips")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$35.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat1.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Golden Onion Rings")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$21.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat1.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Meltdown Nachos")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$17.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat4.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Wild Veggies Sandwich")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$15.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat3.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Garlic Capresse Pizza")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$43.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat2.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Charcoal Chicken Wings")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$18.00")])]), _vm._v(" "), _c('li', [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/menu/menu_photo.png",
      "alt": "menu-dish"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "/static/assets/images/menu/full_size.png"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/menu-cat4.png",
      "alt": "burger item"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("The Volcano Sandwich")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed eiusmod tempor.")]), _vm._v(" "), _c('p', [_vm._v("$12.00")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "specials"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/ivy.png",
      "alt": "ivy"
    }
  }), _vm._v(" "), _c('figure', {
    attrs: {
      "id": "board"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/specials-title.png",
      "alt": "specials-title"
    }
  }), _vm._v(" "), _c('article', [_c('article', [_c('h5', [_vm._v("Mozzarella Cheeseburger")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', [_vm._v("$15.00")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit, sed do eiusmod tempor.")]), _vm._v(" "), _c('article', [_c('h5', [_vm._v("Dark Side Bacon Pizza")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', [_vm._v("$32.00")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit, sed do eiusmod tempor.")]), _vm._v(" "), _c('article', [_c('h5', [_vm._v("Meltdown Nachos")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', [_vm._v("$17.00")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit, sed do eiusmod tempor.")]), _vm._v(" "), _c('article', [_c('h5', [_vm._v("Golden Onion Rings")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('p', [_vm._v("$21.00")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit, sed do eiusmod tempor.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "about"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("About Mozzarella")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('article', [_c('h5', [_vm._v("How did we Become "), _c('span', [_vm._v("this Succesful")])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incidid ut labore et dolore magna porem ed ipsum dolor sit amet, do consectetur ut tempor magna. tem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, do consectetur ut tempor magna.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, do consectetur ut tempor magna. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do re eiusmod diren tempor incididunt ut labore et dolore magna porem ed ipsum dolor sit amet, do consectetur ut tempor magna.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Vintage Arcade Machines")]), _vm._v(" "), _c('li', [_vm._v("The Best 80's and 90's Music")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("5 New Pool Tables")]), _vm._v(" "), _c('li', [_vm._v("Happy Hour until 2AM")])])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/about-img.jpg",
      "alt": "about-img"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quality-badge.png",
      "alt": "quality-badge"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "video"
    }
  }, [_c('p', [_vm._v("Find yourself at the")]), _vm._v(" "), _c('h2', [_vm._v("Last "), _c('span', [_vm._v("Friday")]), _vm._v(" Party")]), _vm._v(" "), _c('div', {
    staticClass: "radial-progress"
  }, [_c('div', {
    staticClass: "r-circle"
  }, [_c('div', {
    staticClass: "mask full"
  }, [_c('div', {
    staticClass: "fill"
  })]), _vm._v(" "), _c('div', {
    staticClass: "mask half"
  }, [_c('div', {
    staticClass: "fill"
  }), _vm._v(" "), _c('div', {
    staticClass: "fill fix"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inset"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/play-button.png",
      "alt": "play-button"
    }
  })])]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": "http://player.vimeo.com/video/109558222"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "reviews"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Customer Reviews")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('li', [_c('article', [_c('div', {
    staticClass: "circle tiny"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/customer-1.png",
      "alt": "customer"
    }
  })])]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-empty-icon.png",
      "alt": "star-empty"
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("James D.")]), _vm._v(" "), _c('p', [_vm._v("25 Years")])]), _vm._v(" "), _c('article', {
    staticClass: "quote"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/quote-left.png",
      "alt": "quote left"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-right.png",
      "alt": "quote right"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-triangle.png",
      "alt": "quote triangle"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor incididunt ut labore etorn dolore eu "), _c('span', [_vm._v("magna porem")]), _vm._v(" ed ipsum dolor sit amet, do lorem consectetur utend tempor magna. Lorem ipsum dolor sit amet, consectetur elar adipisicing elit.")])])]), _vm._v(" "), _c('li', [_c('article', [_c('div', {
    staticClass: "circle tiny"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/customer-2.png",
      "alt": "customer"
    }
  })])]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star-empty"
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("Laura B.")]), _vm._v(" "), _c('p', [_vm._v("27 Years")])]), _vm._v(" "), _c('article', {
    staticClass: "quote"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/quote-left.png",
      "alt": "quote left"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-right.png",
      "alt": "quote right"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-triangle.png",
      "alt": "quote triangle"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor.")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor incididunt ut labore etorn dolore eu "), _c('span', [_vm._v("magna porem")]), _vm._v(" ed ipsum dolor.")])])]), _vm._v(" "), _c('li', [_c('article', [_c('div', {
    staticClass: "circle tiny"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/customer-3.png",
      "alt": "customer"
    }
  })])]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star-empty"
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("Sarah H.")]), _vm._v(" "), _c('p', [_vm._v("22 Years")])]), _vm._v(" "), _c('article', {
    staticClass: "quote"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/quote-left.png",
      "alt": "quote left"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-right.png",
      "alt": "quote right"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-triangle.png",
      "alt": "quote triangle"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor "), _c('span', [_vm._v("incididunt")]), _vm._v(" ut labore etorn dolore eu magna porem ed ipsum dolor sit amet, do lorem consectetur utend tempor magna.")])])]), _vm._v(" "), _c('li', [_c('article', [_c('div', {
    staticClass: "circle tiny"
  }, [_c('figure', {
    staticClass: "imgLiquidFill"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/customer-4.png",
      "alt": "customer"
    }
  })])]), _vm._v(" "), _c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-icon.png",
      "alt": "star"
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": "/static/assets/images/star-empty-icon.png",
      "alt": "star-empty"
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("Jack S.")]), _vm._v(" "), _c('p', [_vm._v("22 Years")])]), _vm._v(" "), _c('article', {
    staticClass: "quote"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/quote-left.png",
      "alt": "quote left"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-right.png",
      "alt": "quote right"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/quote-triangle.png",
      "alt": "quote triangle"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, enu sede do re eiusmod diren tempor incididunt ut labore etorn dolore eu "), _c('span', [_vm._v("magna porem")]), _vm._v(" ed ipsum dolor sit amet, do lorem consectetur utend tempor magna. Lorem ipsum dolor sit amet, consectetur elar adipisicing elit.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "news"
    }
  }, [_c('p', [_vm._v("Do you wanna hear the latests news?")]), _vm._v(" "), _c('h4', [_vm._v("Subscribe to "), _c('span', [_vm._v("our Newsletter")])]), _vm._v(" "), _c('article', [_c('form', [_c('input', {
    attrs: {
      "type": "email",
      "id": "subs_email",
      "name": "subs_email",
      "placeholder": "Enter your email to subscribe..."
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "id": "subs",
      "value": "Subscribe"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subs-error"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "contact"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Contact Us")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', [_c('input', {
    attrs: {
      "type": "text",
      "id": "name",
      "name": "name",
      "placeholder": "Write your full name here..."
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "email",
      "id": "email",
      "name": "email",
      "placeholder": "Write your email adress here..."
    }
  }), _vm._v(" "), _c('textarea', {
    attrs: {
      "id": "message",
      "name": "message",
      "placeholder": "Write your message here..."
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "id": "ctc",
      "name": "ctc",
      "value": "Send your Message"
    }
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Facebook"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/fb-icon.png",
      "alt": "face-icon"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Twitter"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/twitter-icon.png",
      "alt": "twitter-icon"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Flickr"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/flickr-icon.png",
      "alt": "flickr-icon"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Rss"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/rss-icon.png",
      "alt": "rss-icon"
    }
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Vimeo"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/vimeo-icon.png",
      "alt": "vimeo-icon"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13e458f4"}!./src/pages/Home/template.html
// module id = 233
// module chunks = 0